import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  contentWrapper: {
    paddingBottom: '5rem',
  },
  filesHeader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  filesCountText: {
    textAlign: 'right',
    fontSize: '1.6rem',
    lineHeight: '1.8rem',
    margin: 0,
  },
  totalFiles: { marginLeft: '1rem' },
  sectionTitle: {
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 700,
    },
    letterSpacing: '0.1rem',
    color: colors.neutral[700],
    textTransform: 'uppercase',
    margin: '0 0 1.6rem 0',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
